export const fetchOptions = {
  jsonHeaders: {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  },
  acceptJsonHeaders: {
    headers: {
      Accept: "application/json",
    },
  },
  noStoreCache: {
    cache: "no-store",
  },
  noStoreAcceptJson: {
    cache: "no-store",
    headers: {
      Accept: "application/json",
    },
  },
};

